import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=49d2b9b8&scoped=true&"
import script from "./CardHeader.vue?vue&type=script&lang=js&"
export * from "./CardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d2b9b8",
  null
  
)

export default component.exports